import { i18n } from "commonAssets/js/constants";
import { createElement } from "./createElement.js";

export const messageBox = (userLanguage) => {
    return createElement(
        "form",
        { id: "contactForm", class: "collapse", method: "post" },
        [
            createElement("div", { class: "form-group" }, [
                createElement(
                    "label",
                    { for: "email_address" },
                    [],
                    i18n.getTranslation("email_address")
                ),
                createElement("input", {
                    type: "text",
                    class: "form-control",
                    id: "email_address",
                    required: true,
                }),
            ]),
            createElement("div", { class: "form-group" }, [
                createElement(
                    "label",
                    { for: "first_name" },
                    [],
                    i18n.getTranslation("first_name")
                ),
                createElement("input", {
                    type: "text",
                    class: "form-control",
                    id: "first_name",
                    required: true,
                }),
            ]),
            createElement("div", { class: "form-group" }, [
                createElement(
                    "label",
                    { for: "last_name" },
                    [],
                    i18n.getTranslation("last_name")
                ),
                createElement("input", {
                    type: "text",
                    class: "form-control",
                    id: "last_name",
                    required: true,
                }),
            ]),
            createElement("div", { class: "form-group" }, [
                createElement(
                    "label",
                    { for: "phone_number_1" },
                    [],
                    i18n.getTranslation("phone_number_1")
                ),
                createElement("input", {
                    type: "text",
                    class: "form-control",
                    id: "phone_number_1",
                    required: true,
                }),
            ]),
            createElement("div", { class: "form-group" }, [
                createElement(
                    "label",
                    { for: "claim_id" },
                    [],
                    i18n.getTranslation("claim_id_if_known")
                ),
                createElement("input", {
                    type: "text",
                    class: "form-control",
                    id: "claim_id",
                }),
            ]),
            createElement("div", { class: "form-group" }, [
                createElement(
                    "label",
                    { for: "reason" },
                    [],
                    i18n.getTranslation("reason")
                ),
                createElement(
                    "select",
                    { class: "form-select", id: "reason", required: true },
                    [
                        createElement(
                            "option",
                            { value: "" },
                            [],
                            i18n.getTranslation("reason_select")
                        ),
                        createElement(
                            "option",
                            {
                                value: i18n.getTranslation(
                                    "contact_us_select_dropdown"
                                )["claim_form"],
                            },
                            [],
                            i18n.getTranslation("contact_us_select_dropdown")[
                                "claim_form"
                            ]
                        ),
                        createElement(
                            "option",
                            {
                                value: i18n.getTranslation(
                                    "contact_us_select_dropdown"
                                )["exclusion"],
                            },
                            [],
                            i18n.getTranslation("contact_us_select_dropdown")[
                                "exclusion"
                            ]
                        ),
                        createElement(
                            "option",
                            {
                                value: i18n.getTranslation(
                                    "contact_us_select_dropdown"
                                )["general_qa"],
                            },
                            [],
                            i18n.getTranslation("contact_us_select_dropdown")[
                                "general_qa"
                            ]
                        ),
                        createElement(
                            "option",
                            {
                                value: i18n.getTranslation(
                                    "contact_us_select_dropdown"
                                )["contact_info_update"],
                            },
                            [],
                            i18n.getTranslation("contact_us_select_dropdown")[
                                "contact_info_update"
                            ]
                        ),
                        createElement(
                            "option",
                            {
                                value: i18n.getTranslation(
                                    "contact_us_select_dropdown"
                                )["status"],
                            },
                            [],
                            i18n.getTranslation("contact_us_select_dropdown")[
                                "status"
                            ]
                        ),
                        createElement(
                            "option",
                            {
                                value: i18n.getTranslation(
                                    "contact_us_select_dropdown"
                                )["payment"],
                            },
                            [],
                            i18n.getTranslation("contact_us_select_dropdown")[
                                "payment"
                            ]
                        ),
                        createElement(
                            "option",
                            {
                                value: i18n.getTranslation(
                                    "contact_us_select_dropdown"
                                )["notice_related"],
                            },
                            [],
                            i18n.getTranslation("contact_us_select_dropdown")[
                                "notice_related"
                            ]
                        ),
                        createElement(
                            "option",
                            {
                                value: i18n.getTranslation(
                                    "contact_us_select_dropdown"
                                )["other"],
                            },
                            [],
                            i18n.getTranslation("contact_us_select_dropdown")[
                                "other"
                            ]
                        ),
                    ]
                ),
            ]),
            createElement("div", { class: "form-group" }, [
                createElement(
                    "label",
                    { for: "message" },
                    [],
                    i18n.getTranslation("message")
                ),
                createElement("textarea", {
                    class: "form-control",
                    id: "message",
                    rows: 3,
                    required: true,
                }),
            ]),
        ]
    );
};
